angular.module('SpidApp')

.constant('PrixServiceAffranchissementDestinationAdapterConfig', {
  name : 'PrixServiceAffranchissementDestination',
  fields : [
    {
    	local   : 'code_service_speciaux',
    	distant : 'code_service_speciaux'
    }, {
    	local   : 'code_acheminement',
    	distant : 'code_acheminement'
    }, {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'code_destination',
    	distant : 'code_destination'
    }, {
    	local   : 'tranche_inferieure',
    	distant : 'tranche_inferieure'
    }, {
    	local   : 'tranche_superieure',
    	distant : 'tranche_superieure'
    }, {
    	local   : 'prix',
    	distant : 'prix'
    }, {
    	local   : 'unite',
    	distant : 'unite'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'impression',
    	distant : 'impression'
    }
  ]
})
